module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " m-t-0 w-1200"
  }, [_c('el-button', {
    staticClass: "fr m-l-50 m-b-10",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("添加配置")]), _c('span', {
    staticClass: "m-l-30",
    staticStyle: {
      "font-weight": "600",
      "color": "#00f"
    }
  }, [_vm._v("配置描述【配置名称】配置内容")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "m-t-0 padding-page",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "400px"
    }
  }, [_c('div', {
    staticClass: "form-pane"
  }, _vm._l((_vm.form.list), function(item) {
    return _c('el-form-item', {
      attrs: {
        "label": item.remark + ' 【' + item.name + '】',
        "prop": "list"
      }
    }, [(item.type == 1) ? _c('el-input', {
      staticClass: "m-l-10 h-40 w-400",
      attrs: {
        "value": item.value
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.value"
      }
    }) : _c('el-radio-group', {
      staticClass: "m-l-10 h-40 w-400",
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.value"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("关闭")])], 1)], 1)
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "m-l-10 w-200",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "上传图片",
      "visible": _vm.picFormVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.picFormVisible = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "m-b-20",
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "show-file-list": false,
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "default-file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("正方形图片;只能上传jpg/png文件")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.pic
    }
  }), _vm._v(" "), _c('p', [_vm._v("图片地址："), _c('b', {
    attrs: {
      "id": "cpLink"
    }
  }, [_vm._v(_vm._s(_vm.pic))])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加配置",
      "visible": _vm.dialogFormVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.formconfig,
      "label-width": "30%",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "配置名称",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：SET_NAME"
    },
    model: {
      value: (_vm.formconfig.name),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置描述",
      "prop": "remark",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：前端展示——平台名称"
    },
    model: {
      value: (_vm.formconfig.remark),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置内容",
      "prop": "value",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：小程序，单选按钮填0或1"
    },
    model: {
      value: (_vm.formconfig.value),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "选择配置的展示类型"
    },
    model: {
      value: (_vm.formconfig.type),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "type", $$v)
      },
      expression: "formconfig.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "输入框",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "单选按钮",
      "value": 2
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.save('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22fb09d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/config/appconfig/add.vue
// module id = 1814
// module chunks = 2